import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';

import {ApiMessageService} from '../../core/api-message.service';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';
import {Utente} from './utente.model';

@Injectable()
export class UtenteService extends CommonService<Utente> {

  public static ROUTE = 'utente';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Utente {
    return JsonBaseBuilder.jsonToUtente(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return UtenteService.ROUTE;
  }

  public existingUsername(username: string, entity: Utente): Observable<boolean> {
    return this.getBoolean('/existingusername', new HttpParams()
      .set('username', username)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public existingEmail(email: string, entity: Utente): Observable<boolean> {
    return this.getBoolean('/existingemail', new HttpParams()
      .set('email', email)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public getTable(items: Utente[]): Table {
    return Table.buildBaseTable(Utente.getTableKeys(), items);
  }

  public byUsername(username: string): Observable<Utente> {
    return this.getEntity('/' + username, new HttpParams());
  }

}
